import React from 'react';
import SectionIncomingConsignment from '../SectionIncomingConsignment';

const GoodsTransferIncomingConsignment = () => {
  return (
    <SectionIncomingConsignment 
      sectionName="Goods Transfer"
      sectionDisplayName="Goods Transfer"
      backRoute="/sections/goods-transfer"
    />
  );
};

export default GoodsTransferIncomingConsignment;
